import useSWR from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { fetcher } from '@/utils/services';

const useConstituentGivingSummaries = (constituentId) => {
  const ownerOrgId = useOwnerOrgId();

  const { data, error, isValidating } = useSWR(
    `reporting/${ownerOrgId}/constituents/${constituentId}/giving-summary`,
    fetcher,
  );

  return {
    constituentId,
    data,
    error,
    isValidating,
    ownerOrgId,
  };
};

export default useConstituentGivingSummaries;
